import React, { ReactElement } from 'react';
import { Box, Text } from '@razorpay/blade/components';

export const EmptyTableCard = ({
  itemLabel,
}: {
  itemLabel?: string;
}): ReactElement => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      backgroundColor="surface.background.gray.intense"
      padding="spacing.7"
      borderRadius="large">
      <Text
        size="large"
        textAlign="center">
        No {itemLabel || 'Rows'} Uploaded
      </Text>
    </Box>
  );
};
